/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */

import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import ACCOUNT_ACTION_TYPES, {
  AccountLeverageActionType,
  KycImportActionType,
  SignalTradingActionType,
} from 'actionTypes/account';
import { SAVE_CHART } from 'actionTypes/other';
import { SHARE_CARD } from 'actionTypes/shareCard';

import BASKET_ORDERS from '../actionTypes/basketorders';
import ORDER_BOOK, { ORDER_BOOK_STALE } from '../actionTypes/orderbook';
import TRADE from '../actionTypes/trade';
import USER, { RATE_LIMIT_EXCEEDED, USER_SIGNUP_FAIL } from '../actionTypes/user';
import WALLET from '../actionTypes/wallet';
import { getProductByID } from '../selectors/tradeSelectors';

export const getProductByIDHelper = (state, product_id) =>
  getProductByID(state, {
    filterProductId: product_id,
  });

const TYPES = [
  TRADE.ORDER.LOAD,
  TRADE.CLOSE_POSITION.LOAD,
  TRADE.ORDER_CANCEL.SUCCESS,
  TRADE.CLOSE_POSITION.SUCCESS,
  TRADE.CLOSE_ALL_POSITION.SUCCESS,
  TRADE.CLOSE_ALL_POSITION.FAIL,
  TRADE.CLOSE_POSITION_BASKET.SUCCESS,
  TRADE.CLOSE_POSITION_BASKET.FAIL,
  TRADE.ORDER.FAIL,
  TRADE.CLOSE_POSITION.FAIL,
  TRADE.ORDER.SUCCESS,
  TRADE.ORDER_CANCEL.FAIL,
  TRADE.WITHDRAWAL_DATA.FAIL,
  TRADE.GET_WITHDRAWAL_OTP.FAIL,
  TRADE.WITHDRAWAL_DATA.SUCCESS,
  TRADE.CANCEL_WITHDRAWAL.SUCCESS,
  TRADE.CANCEL_WITHDRAWAL.FAIL,
  TRADE.WITHDRAWAL_TRADING_CREDITS_FORFEIT.SUCCESS,
  TRADE.WITHDRAWAL_TRADING_CREDITS_FORFEIT.FAIL,
  TRADE.SHARE_CARD.FAIL,
  TRADE.UPDATE_TRADE_PREFERENCE.SUCCESS,
  TRADE.UPDATE_TRADE_PREFERENCE.FAIL,
  TRADE.UPDATE_PORTFOLIO_MARGIN_NOTIFICATION.FAIL,
  TRADE.BRACKET_ORDER.SUCCESS,
  TRADE.BRACKET_ORDER.FAIL,
  TRADE.PLACE_BRACKET_ORDER_POSITION.FAIL,
  TRADE.EDIT_BRACKET_ORDER.SUCCESS,
  TRADE.EDIT_BRACKET_ORDER.FAIL,
  TRADE.CANCEL_BRACKET_ORDER.SUCCESS,
  TRADE.CANCEL_BRACKET_ORDER_POSITION.SUCCESS,
  TRADE.UPDATE_BRACKET_ORDER_FROM_OPEN_ORDER.SUCCESS,
  TRADE.CANCEL_BRACKET_ORDER.FAIL,
  ORDER_BOOK.CHANGE_ORDER_LEVERAGE.SUCCESS,
  ORDER_BOOK.CHANGE_ORDER_LEVERAGE.FAIL,
  ORDER_BOOK_STALE,
  USER.CHANGE_PASSWORD.SUCCESS,
  USER.CREATE_WITHDRAWAL_ADDRESS.SUCCESS,
  USER.DELETE_WITHDRAWAL_ADDRESS.SUCCESS,
  USER.DELETE_WITHDRAWAL_ADDRESS.FAIL,
  USER.RESET_PASSWORD.FAIL,
  USER.UPDATE_PROFILE.SUCCESS,
  USER.UPDATE_PROFILE.FAIL,
  USER.LOGINMFA.FAIL,
  USER.LOGIN.FAIL,
  USER.ENABLE_MFA.SUCCESS,
  USER.RESET_MFA.SUCCESS,
  USER_SIGNUP_FAIL,
  USER.LOGOUT_FROM_ALL_DEVICES.FAIL,
  USER.LOGOUT_FROM_ALL_DEVICES.SUCCESS,
  USER.DISABLE_MFA.FAIL,
  USER.DISABLE_MFA.SUCCESS,
  USER.CREATE_API_KEY.SUCCESS,
  USER.DELETE_API_KEY.SUCCESS,
  USER.DELETE_API_KEY.FAIL,
  USER.APPLY_PROMO.SUCCESS,
  USER.APPLY_PROMO.FAIL,
  USER.UPDATE_PREFERENCES.SUCCESS,
  USER.CONSENT_LOGIN.FAIL,
  RATE_LIMIT_EXCEEDED,
  WALLET.CHANGE_MARGIN.SUCCESS,
  WALLET.CHANGE_MARGIN.FAIL,
  WALLET.CONVERT_CURRENCY.SUCCESS,
  WALLET.CONVERT_CURRENCY.FAIL,
  WALLET.TRANSFER_FUNDS_SPOT.SUCCESS,
  WALLET.TRANSFER_FUNDS_SPOT.FAIL,
  WALLET.WITHDRAWAL_RESEND_CONFIRMATION.SUCCESS,
  WALLET.WITHDRAWAL_RESEND_CONFIRMATION.FAIL,
  BASKET_ORDERS.PLACE_ORDER.SUCCESS,
  TRADE.UPDATE_BRACKET_ORDER_FROM_OPEN_ORDER.FAIL,
  USER.GET_ACCOUNT_TOKEN.FAIL,
  TRADE.CANCEL_ALL_ORDER.SUCCESS,
  USER.WITHDRAWAL_PENDING_COUNT.SUCCESS,
  TRADE.CANCEL_ALL_ORDER.FAIL,
  TRADE.POSITION_AUTO_TOPUP.SUCCESS,
  TRADE.TICKER.SUCCESS,
  TRADE.ALL_TICKERS.SUCCESS,
  SAVE_CHART,
  USER.TRANSFER_FUNDS_SUB_ACCOUNTS.SUCCESS,
  USER.CREATE_SUB_ACCOUNT.SUCCESS,
  USER.LOGIN_EMAIL_VERIFICATION.FAIL,
  USER.GET_KYC_VENDOR_LINK.FAIL,
  USER.GET_USER_PROFILE.SUCCESS,
  ACCOUNT_ACTION_TYPES[KycImportActionType.IMPORT_KYC_FROM_GLOBAL].FAIL,
  ACCOUNT_ACTION_TYPES[KycImportActionType.IMPORT_KYC_FROM_GLOBAL].SUCCESS,
  ACCOUNT_ACTION_TYPES[SignalTradingActionType.DELETE_WEBHOOK].FAIL,
  TRADE.WALLET_BALANCE_TOP_UP.FAIL,
  TRADE.WALLET_BALANCE_TOP_UP.SUCCESS,
  TRADE.CREATE_CUSTOM_PRICE_ALERT.SUCCESS,
  TRADE.CREATE_CUSTOM_PRICE_ALERT.FAIL,
  TRADE.DELETE_CUSTOM_PRICE_ALERT.SUCCESS,
  TRADE.DELETE_CUSTOM_PRICE_ALERT.FAIL,
  TRADE.POSITIONS.FAIL,
  TRADE.OPEN_ORDERS.FAIL,
  TRADE.OPEN_STOP_ORDERS.FAIL,
  WALLET.BALANCES.FAIL,
  ACCOUNT_ACTION_TYPES[AccountLeverageActionType.UPDATE_ACCOUNT_LEVERAGE].SUCCESS,
  ACCOUNT_ACTION_TYPES[AccountLeverageActionType.UPDATE_ACCOUNT_LEVERAGE].FAIL,
  SHARE_CARD.IMAGE_GENERATION_FAIL,
];

const alertsEpic = (action$, state$) =>
  action$.pipe(
    ofType(...TYPES),
    mergeMap(async action => {
      // eslint-disable-next-line import/no-cycle
      const { alerts } = await import('./utils/alertHandlers');
      return alerts[action.type](action, state$.value);
    })
  );

export default alertsEpic;
